import React from 'react';
import PropTypes from 'prop-types';
import moneyFormatter from 'helpers/money-formatter';
import needDollarSign from 'constants/need-currency';

const PowerTableTr = props => (
  <tr
    onClick={props.onClick}
    style={{ cursor: 'pointer' }}
  >
    { props.keys.map(key =>
      (
        <td key={key}>
          {needDollarSign.includes(key) ? moneyFormatter(props.row[key]) : props.row[key]}
        </td>))}
  </tr>
);

PowerTableTr.propTypes = {
  row: PropTypes.shape({}),
  keys: PropTypes.arrayOf(PropTypes.string),
  onClick: PropTypes.func,
};

export default PowerTableTr;



// WEBPACK FOOTER //
// ./src/components/PowerTable/PowerTableTr/PowerTableTr.jsx